// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/Register-bg.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/images/Login-bg.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/images/login-register-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Public+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
   font-family: "Public Sans", sans-serif;
}

body{
   padding-top: 50px;
}
.bill-slip {
   border: 1px solid #e2e8f0;
   border-radius: 8px;
   padding: 16px;
   background-color: #f7fafc;
}


.bill-slip h2,
.bill-slip h3 {
   color: #2d3748;
}

.bill-slip p {
   color: #4a5568;
}

.bill-slip .bill-items {
   margin: 0;
   padding: 0;
   list-style: none;
}

.bill-slip .bill-items li {
   padding: 4px 0;
}

.bill-slip .bill-total {
   color: #2d3748;
   font-weight: bold;
   text-align: right;
   margin-top: 16px;
}


.sidebar-item{
   position: relative;
   overflow: hidden;
}

.sidebar-item::before{
   position: absolute;
   bottom: 0px;
   right: 0px;
   height: 3px;
   --tw-bg-opacity: 1;
   background-color: rgb(13 148 136 / var(--tw-bg-opacity));
   content: '';
   width: 0;
   transition: width 0.3s ease;
}

.sidebar-item:hover::before {
   width: 100%;
   left: 0;
}

.sidebar-item.active::before {
   width: 100%;
   left: 0;
}

.example::-webkit-scrollbar {
   display: none;
}

.hn {
   width: 600px;
   overflow-x: scroll;

}


@media screen {

   .address,
   .thanks {
      display: none;
   }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
   -webkit-appearance: none;
   margin: 0;
}

input[type=number] {
   -moz-appearance: textfield;
}

#timeline {
   animation: grow 1s ease-in-out infinite alternate;
}

@keyframes grow {
   from {
      stroke-dasharray: 0 10;
   }

   to {
      stroke-dasharray: 10 10;
   }
}

.img {
   background-image:
      url(${___CSS_LOADER_URL_REPLACEMENT_0___}),
      url(${___CSS_LOADER_URL_REPLACEMENT_1___});

   background-repeat: no-repeat, no-repeat;

   background-size: 80vh,80vh;

   background-position: top left, bottom right;

   /* background-color: #f0f0f0; */
}

@media (max-width: 768px) {
   .img {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
   }
}

@media (max-width: 480px) {
   .img {
      background-size: cover;
      background-position: center;
   }
}

.img2 {
   background-image:
      url(${___CSS_LOADER_URL_REPLACEMENT_0___}),
      url(${___CSS_LOADER_URL_REPLACEMENT_1___});

   background-repeat: no-repeat, no-repeat;

   background-size: 80vh, 80vh;

   background-position: top left, bottom right;

   /* background-color: #f0f0f0; */
}

@media (max-width: 768px) {
   .img2 {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
   }

   .bill {
      margin-top: 28px;
      padding-bottom: 10px;
   }
}

@media (max-width: 480px) {
   .img2 {
      background-size: cover;
      background-position: center;
   }
}

.register_background {
   background-color: #18181a9c;
}

.blur {
   filter: blur(3px);
}

.adminepanel {
   border-radius: 45px;
}

::placeholder {
   color: black !important;
}

.common_btn {
   color: white;
   background: blue;
   border-radius: 5px;
   padding: 12px 25px;
   transition: all 0.3s ease-in-out;
   border: 1px solid blue;
   line-height: 21px;
}

.common_btn:focus,
.common_btn:hover {
   animation: pulse 0.7s;
   -webkit-animation: pulse 0.7s;
   box-shadow: 0 0 0 0.3em transparent;
   color: blue !important;
   background: transparent !important;
   border: 1px solid blue !important;
}

@keyframes pulse {
   0% {
      box-shadow: 0 0 0 blue;
   }
}

.modal-container {
   max-height: 100vh;
   overflow-y: auto;
}

.beta {
   font-size: 10px;
   top: 5px;
   right: 4px;
}

/* .product_table {
   padding-left: 20px;
} */

@media (max-width: 768) {
   .product_table {
      padding-left: 0px;
   }
}

/* style for input placeholder */
input::placeholder,
textarea::placeholder {
  color: #9ca3af !important; /* gray-400 */
}

@media print {

  body {
    padding-top: 0 !important;
  }

  /* Remove shadows */
  .shadow,
  .shadow-md,
  .shadow-lg {
    box-shadow: none !important;
  }

  /* Remove border radius */
  .rounded,
  .rounded-lg,
  .rounded-xl {
    border-radius: 0 !important;
  }

  /* Remove modal background */
  .fixed,
  .bg-black,
  .bg-opacity-50 {
    background: transparent !important;
  }

  /* Remove unwanted borders */
  .bill-slip {
    border: none !important;
    background: white !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;GACG,sCAAsC;AACzC;;AAEA;GACG,iBAAiB;AACpB;AACA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,aAAa;GACb,yBAAyB;AAC5B;;;AAGA;;GAEG,cAAc;AACjB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,SAAS;GACT,UAAU;GACV,gBAAgB;AACnB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,cAAc;GACd,iBAAiB;GACjB,iBAAiB;GACjB,gBAAgB;AACnB;;;AAIG;GAAA,kBAA+B;GAA/B;AAA+B;;AAI/B;GAAA,kBAAwD;GAAxD,WAAwD;GAAxD,UAAwD;GAAxD,WAAwD;GAAxD,kBAAwD;GAAxD,wDAAwD;GACxD,WAAW;GACX,QAAQ;GACR;AAHwD;;AAM3D;GACG,WAAW;GACX,OAAO;AACV;;AAEA;GACG,WAAW;GACX,OAAO;AACV;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,YAAY;GACZ,kBAAkB;;AAErB;;;AAGA;;GAEG;;MAEG,aAAa;GAChB;AACH;;AAEA;;GAEG,wBAAwB;GACxB,SAAS;AACZ;;AAEA;GACG,0BAA0B;AAC7B;;AAEA;GACG,iDAAiD;AACpD;;AAEA;GACG;MACG,sBAAsB;GACzB;;GAEA;MACG,uBAAuB;GAC1B;AACH;;AAEA;GACG;;6CAEsC;;GAEtC,uCAAuC;;GAEvC,0BAA0B;;GAE1B,2CAA2C;;GAE3C,+BAA+B;AAClC;;AAEA;GACG;MACG,yDAA8D;MAC9D,sBAAsB;MACtB,2BAA2B;MAC3B,4BAA4B;GAC/B;AACH;;AAEA;GACG;MACG,sBAAsB;MACtB,2BAA2B;GAC9B;AACH;;AAEA;GACG;;6CAEsC;;GAEtC,uCAAuC;;GAEvC,2BAA2B;;GAE3B,2CAA2C;;GAE3C,+BAA+B;AAClC;;AAEA;GACG;MACG,yDAA8D;MAC9D,sBAAsB;MACtB,2BAA2B;MAC3B,4BAA4B;GAC/B;;GAEA;MACG,gBAAgB;MAChB,oBAAoB;GACvB;AACH;;AAEA;GACG;MACG,sBAAsB;MACtB,2BAA2B;GAC9B;AACH;;AAEA;GACG,2BAA2B;AAC9B;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,YAAY;GACZ,gBAAgB;GAChB,kBAAkB;GAClB,kBAAkB;GAClB,gCAAgC;GAChC,sBAAsB;GACtB,iBAAiB;AACpB;;AAEA;;GAEG,qBAAqB;GACrB,6BAA6B;GAC7B,mCAAmC;GACnC,sBAAsB;GACtB,kCAAkC;GAClC,iCAAiC;AACpC;;AAEA;GACG;MACG,sBAAsB;GACzB;AACH;;AAEA;GACG,iBAAiB;GACjB,gBAAgB;AACnB;;AAEA;GACG,eAAe;GACf,QAAQ;GACR,UAAU;AACb;;AAEA;;GAEG;;AAEH;GACG;MACG,iBAAiB;GACpB;AACH;;AAEA,gCAAgC;AAChC;;EAEE,yBAAyB,EAAE,aAAa;AAC1C;;AAEA;;EAEE;IACE,yBAAyB;EAC3B;;EAEA,mBAAmB;EACnB;;;IAGE,2BAA2B;EAC7B;;EAEA,yBAAyB;EACzB;;;IAGE,2BAA2B;EAC7B;;EAEA,4BAA4B;EAC5B;;;IAGE,kCAAkC;EACpC;;EAEA,4BAA4B;EAC5B;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Public+Sans:ital,wght@0,100..900;1,100..900&display=swap');\n\n* {\n   font-family: \"Public Sans\", sans-serif;\n}\n\nbody{\n   padding-top: 50px;\n}\n.bill-slip {\n   border: 1px solid #e2e8f0;\n   border-radius: 8px;\n   padding: 16px;\n   background-color: #f7fafc;\n}\n\n\n.bill-slip h2,\n.bill-slip h3 {\n   color: #2d3748;\n}\n\n.bill-slip p {\n   color: #4a5568;\n}\n\n.bill-slip .bill-items {\n   margin: 0;\n   padding: 0;\n   list-style: none;\n}\n\n.bill-slip .bill-items li {\n   padding: 4px 0;\n}\n\n.bill-slip .bill-total {\n   color: #2d3748;\n   font-weight: bold;\n   text-align: right;\n   margin-top: 16px;\n}\n\n\n.sidebar-item {\n   @apply relative overflow-hidden;\n}\n\n.sidebar-item::before {\n   @apply absolute bottom-[0px] right-0 h-[3px] bg-teal-600;\n   content: '';\n   width: 0;\n   transition: width 0.3s ease;\n}\n\n.sidebar-item:hover::before {\n   width: 100%;\n   left: 0;\n}\n\n.sidebar-item.active::before {\n   width: 100%;\n   left: 0;\n}\n\n.example::-webkit-scrollbar {\n   display: none;\n}\n\n.hn {\n   width: 600px;\n   overflow-x: scroll;\n\n}\n\n\n@media screen {\n\n   .address,\n   .thanks {\n      display: none;\n   }\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n   -webkit-appearance: none;\n   margin: 0;\n}\n\ninput[type=number] {\n   -moz-appearance: textfield;\n}\n\n#timeline {\n   animation: grow 1s ease-in-out infinite alternate;\n}\n\n@keyframes grow {\n   from {\n      stroke-dasharray: 0 10;\n   }\n\n   to {\n      stroke-dasharray: 10 10;\n   }\n}\n\n.img {\n   background-image:\n      url('./assets/images/Register-bg.gif'),\n      url('./assets/images/Login-bg.gif');\n\n   background-repeat: no-repeat, no-repeat;\n\n   background-size: 80vh,80vh;\n\n   background-position: top left, bottom right;\n\n   /* background-color: #f0f0f0; */\n}\n\n@media (max-width: 768px) {\n   .img {\n      background-image: url('./assets/images/login-register-bg.jpg');\n      background-size: cover;\n      background-position: center;\n      background-repeat: no-repeat;\n   }\n}\n\n@media (max-width: 480px) {\n   .img {\n      background-size: cover;\n      background-position: center;\n   }\n}\n\n.img2 {\n   background-image:\n      url('./assets/images/Register-bg.gif'),\n      url('./assets/images/Login-bg.gif');\n\n   background-repeat: no-repeat, no-repeat;\n\n   background-size: 80vh, 80vh;\n\n   background-position: top left, bottom right;\n\n   /* background-color: #f0f0f0; */\n}\n\n@media (max-width: 768px) {\n   .img2 {\n      background-image: url('./assets/images/login-register-bg.jpg');\n      background-size: cover;\n      background-position: center;\n      background-repeat: no-repeat;\n   }\n\n   .bill {\n      margin-top: 28px;\n      padding-bottom: 10px;\n   }\n}\n\n@media (max-width: 480px) {\n   .img2 {\n      background-size: cover;\n      background-position: center;\n   }\n}\n\n.register_background {\n   background-color: #18181a9c;\n}\n\n.blur {\n   filter: blur(3px);\n}\n\n.adminepanel {\n   border-radius: 45px;\n}\n\n::placeholder {\n   color: black !important;\n}\n\n.common_btn {\n   color: white;\n   background: blue;\n   border-radius: 5px;\n   padding: 12px 25px;\n   transition: all 0.3s ease-in-out;\n   border: 1px solid blue;\n   line-height: 21px;\n}\n\n.common_btn:focus,\n.common_btn:hover {\n   animation: pulse 0.7s;\n   -webkit-animation: pulse 0.7s;\n   box-shadow: 0 0 0 0.3em transparent;\n   color: blue !important;\n   background: transparent !important;\n   border: 1px solid blue !important;\n}\n\n@keyframes pulse {\n   0% {\n      box-shadow: 0 0 0 blue;\n   }\n}\n\n.modal-container {\n   max-height: 100vh;\n   overflow-y: auto;\n}\n\n.beta {\n   font-size: 10px;\n   top: 5px;\n   right: 4px;\n}\n\n/* .product_table {\n   padding-left: 20px;\n} */\n\n@media (max-width: 768) {\n   .product_table {\n      padding-left: 0px;\n   }\n}\n\n/* style for input placeholder */\ninput::placeholder,\ntextarea::placeholder {\n  color: #9ca3af !important; /* gray-400 */\n}\n\n@media print {\n\n  body {\n    padding-top: 0 !important;\n  }\n\n  /* Remove shadows */\n  .shadow,\n  .shadow-md,\n  .shadow-lg {\n    box-shadow: none !important;\n  }\n\n  /* Remove border radius */\n  .rounded,\n  .rounded-lg,\n  .rounded-xl {\n    border-radius: 0 !important;\n  }\n\n  /* Remove modal background */\n  .fixed,\n  .bg-black,\n  .bg-opacity-50 {\n    background: transparent !important;\n  }\n\n  /* Remove unwanted borders */\n  .bill-slip {\n    border: none !important;\n    background: white !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
